import { CobrandInfoActionTypes } from '../../actions';
import { ICobrandProgram } from 'src/app/models/cobrand-model';

export interface State {
  loaded: boolean;
  error: any;
  cobrandInfo?: ICobrandProgram | null;
}

export const initialState: State = {
  loaded: false,
  error: null,
  cobrandInfo: null,
};

export function reducer(state: State = initialState , action: any): State {
  switch (action.type) {
    case CobrandInfoActionTypes.GET_COBRAND_INFO:
        return {
        ...state,
        loaded: false
      };
    case CobrandInfoActionTypes.GET_COBRAND_INFO_SUCCESS:
      return {
        ...state,
        loaded: true,
        cobrandInfo: action.payload
      };
    case CobrandInfoActionTypes.GET_COBRAND_INFO_FAILURE:
      return {
        ...state,
        loaded: true,
        error: action.payload
      };
    case CobrandInfoActionTypes.SKIP_COBRAND_INFO:
      return {
        ...state,
        loaded: true,
        cobrandInfo: null
      };
    default:
      return state;
  }
}

export const getContentCobrandState = (state: State) => state;
export const getContentCobrandInfo = (state: State) => state.cobrandInfo;
